import { Swords } from 'lucide-react';

/**
 * THE GUILD MARK — crossed swords, wherever a guild is named as a thing.
 *
 * Twin of town-square/src/components/guild/GuildMark.tsx; edit both or neither. The two
 * apps cannot import from each other, and a mark that differs between them is not a mark.
 *
 * Not a shield: ShieldCheck is already the VERIFICATION mark in this product, and a
 * second shield would read as a second kind of verification.
 */
export function GuildMark({ size = 16, className }: { size?: number; className?: string }) {
  return <Swords size={size} strokeWidth={1.75} className={className} aria-hidden="true" />;
}
